import { useState } from 'react';
import classNames from 'classnames';
import { Tiers } from '@medifind/shared-basic-components';
import AdWrapper from './adWrapper';
import styles from './ad.shared.module.scss';

const ExpertTiersAd = ({ ...props }) => {
  const [showTiers, setShowTiers] = useState(false);
  const toggleTiers = () => setShowTiers(!showTiers);
  return (
    <>
      <AdWrapper
        {...props}
        icon={
          <div
            className={classNames(styles['tiers__colorswatch'], {
              [styles['tiers__colorswatch--smallAds']]: props.smallAds,
            })}
          >
            <div className={styles['tiers__colorswatch--red']}>&nbsp;</div>
            <div className={styles['tiers__colorswatch--purple']}>&nbsp;</div>
            <div className={styles['tiers__colorswatch--navy']}>&nbsp;</div>
            <div className={styles['tiers__colorswatch--blue']}>&nbsp;</div>
          </div>
        }
        title={`Learn about our expert tiers`}
        onClick={toggleTiers}
        buttonText={showTiers ? 'Close' : 'Learn More'}
      />
      {showTiers && <Tiers className={classNames(styles['tiers__explain'], styles['tiers__explain--mobile'])} />}
    </>
  );
};

export { ExpertTiersAd as default, ExpertTiersAd };
